module.exports = __webpack_public_path__ + "img/passage3d-small-light.dc04fdb5.svg";